import { render, staticRenderFns } from "./PackingListFilter.vue?vue&type=template&id=37e3f3d3&"
import script from "./PackingListFilter.vue?vue&type=script&lang=js&"
export * from "./PackingListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports